import React from 'react';
import styled from 'styled-components';
import { useCustomComponentStateContext } from '../../hooks/useCustomComponentState';

const TitleContainer = styled.h2<{ s?: React.CSSProperties }>(({ s }) => ({
  padding: '1.5rem 0.675rem',
  textAlign: 'center',
  margin: 0,
  ...s,
}));

function SliderTitle() {
  const { state } = useCustomComponentStateContext();

  const retailerTheme = state?.queryData?.retailerTheme;

  const retailerTranslations = state?.queryData?.retailerTranslations;

  const { productRecommendationsCarouselTitle: titleText } =
    retailerTranslations || {};
  if (!titleText) return null;

  const headersMediumNone: unknown = retailerTheme?.headersMediumNone || {};
  const productrecscarouseltitleNoneNone: unknown =
    retailerTheme?.productrecscarouseltitleNoneNone || headersMediumNone || {};

  return (
    <TitleContainer
      s={
        productrecscarouseltitleNoneNone &&
        typeof productrecscarouseltitleNoneNone === 'object'
          ? productrecscarouseltitleNoneNone
          : {}
      }
    >
      {titleText}
    </TitleContainer>
  );
}

export default SliderTitle;
